import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useFeatureValue } from '@growthbook/growthbook-react';
import ProductListingPage from '../../components/ProductListingPage/ProductListingPage';
import useHardwareFirstShop from '../../hooks/useHardwareFirstShop';
import { PDP_SPLIT_FLAG, parsePdpParam, resolvePdpDestination } from './pdpSplit';

/**
 * `/products?pdp=s3` is a paid-ad landing test: the listing vs. the shop narrowed to the named
 * trackers. The growthbook flag's experiment rule picks the arm per visitor, and the redirect happens
 * before the listing mounts so the pdp arm logs no listing page view. Without `pdp=` the listing
 * renders as usual and the flag is never evaluated, so organic traffic is never in the experiment.
 * Visitors the shop would send straight back here (partner, rescue and nano contexts, markets
 * without Mini) are not bucketed either: they would count as the pdp arm while seeing the listing.
 */
export default function ProductsRoute() {
  const { search } = useLocation();
  const shopEnabled = useHardwareFirstShop();
  const devices = parsePdpParam(search);
  return shopEnabled && devices.length > 0 ? <PdpSplit devices={devices} search={search} /> : <ProductListingPage />;
}

function PdpSplit({ devices, search }: { devices: string[]; search: string }) {
  const toPdp = useFeatureValue(PDP_SPLIT_FLAG, false);
  return toPdp ? <Redirect to={resolvePdpDestination(devices, search)} /> : <ProductListingPage />;
}
